import { render, staticRenderFns } from "./QuickPreview.vue?vue&type=template&id=71b3ac17"
import script from "./QuickPreview.vue?vue&type=script&lang=js"
export * from "./QuickPreview.vue?vue&type=script&lang=js"
import style0 from "./QuickPreview.vue?vue&type=style&index=0&id=71b3ac17&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports